import { httpComment } from "Utils/httpComment";
import { http } from "Utils";
import { STATUSES } from "Utils/constants";
import { getRecaptchaToken } from "Components/ReCaptcha";


// get common format list for the commenting tool
const getCommonFormatList = async () => {

  const body = {};

  var url = "/api/ag/ct/docCatList";
  var status = STATUSES.SUCCESS;

  const res = await http.post(url, body, {
    headers: {
    }
  }).then(res => {
    //console.log("getCommonFormatList()", res);

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    // console.log("error caught from validateCtRpt", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

// save one comment for the commenting tool
const saveComment = async (documentComment) => {

  const captchaToken = await getRecaptchaToken('comment_save').catch(() => null);
  const payload = { ...documentComment, captchaToken, captchaAction: 'comment_save' };

  var url = "/api/ag/ct/comment/save";
  var status = STATUSES.SUCCESS;

  const res = await http.post(url, payload, {
    headers: {
      //"Authorization": token
    }
  }).then(res => {
    //console.log("save one comment()", res);
    if (res?.status === -1 && res?.globalErrorMessageList?.length > 0) {
      const err = new Error(res.globalErrorMessageList[0]);
      err.globalErrorMessageList = res.globalErrorMessageList;
      return Promise.reject(err);
    }
    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    // //console.log("error caught from save one comment", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};

// validate comment text for the commenting tool
const validateComment = async (commentText) => {

  //mapping to Comment.java
  const commentDto = {
    // in glassfish commenting tool, there is a domId for comment text field
    domId: "feedback",
    categoryId: null,
    itemId: null,
    commentText: commentText,
    isGeneralComment: true
  }

  //console.log("validateComment() commentDto", commentDto);

  var url = "/api/ag/ct/comment/validateComment";
  var status = STATUSES.SUCCESS;

  const res = await http.post(url, commentDto, {
    headers: {
      //"Authorization": token
    }
  }).then(res => {
    //console.log("validateComment", res);

    return Promise.resolve({ status: status, data: res });

  }).catch(function (error) {
    //console.log("error caught from validateComment", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });
  return res;
};


export { getCommonFormatList, saveComment, validateComment };